import { render, staticRenderFns } from "./addClassifyDialog.vue?vue&type=template&id=34c7f906&scoped=true"
import script from "./addClassifyDialog.vue?vue&type=script&lang=js"
export * from "./addClassifyDialog.vue?vue&type=script&lang=js"
import style0 from "./addClassifyDialog.vue?vue&type=style&index=0&id=34c7f906&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c7f906",
  null
  
)

export default component.exports